import React from 'react'
import { Icon } from 'react-materialize'
import { Route } from 'react-router'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';

import Toolbar from '../toolbar/Toolbar';


import Logo from '../../../assets/images/logo.png'
import HaganaLogo from '../../../assets/images/haganaLogo.jpg'
import Menus from '../../infra/menus/Menus'
import { getUser } from '../../service/AccountService';

import './Sidebar.css'

const ListItemLink = ({ to, icon, text }) => (
  <Route
    path={to}
    exact
    children={({ match }) => (
      <li className={match ? 'active' : ''}>
        <Link to={to}>
          <Icon small>{icon}</Icon>
          {text}

        </Link>
      </li>
    )}
  />
)


class Sidebar extends React.Component {
  state = {
    open: false
  };
  openMenu = () => {
    this.setState((state) => ({ open: true }))
  }
  closeMenu = () => {
    this.setState((state) => ({ open: false }))
  }

  render() {
    const companyId = getUser().companyId

    return (
      <React.Fragment>
        <nav>
          <Link to="/" className="logo">
            <img src={companyId === 319 ? HaganaLogo : Logo} alt="Tranpo - Elastic Work Force" />
          </Link>
          <div className="open-menu" onClick={this.openMenu}>
            <a >
              <Icon>baseline_menu</Icon>
            </a>

          </div>
          <ul className={this.state.open ? 'menu open' : 'menu'} >
            <li className="responsive_header">
              <Link to="/" className="logo">
                <img src={Logo} alt="Tranpo - Elastic Work Force" />
              </Link>
              <i onClick={this.closeMenu} className="close-menu">
                <Icon>clear</Icon>
              </i>
            </li>
            {
              Menus().map((menu, index) => <ListItemLink key={index} to={menu.url} icon={menu.icon} text={menu.text} />)
            }
          </ul>
          <Toolbar />

        </nav>

      </React.Fragment>
    )
  }



}


const mapStateToProps = state => ({
  account: state.account
})

Sidebar = connect(
  mapStateToProps,
  undefined
)(Sidebar)

export default Sidebar



// WEBPACK FOOTER //
// ./src/shared/component/sidebar/Sidebar.jsx